<template>
    <div >
      <div class="d-flex justify-content-between align-item-center mb-3">
        <div class="section-title mb-3">
          {{ $t("edit") }} {{ $tc("productioncompany", 2) }}
        </div>
        <router-link class="btn-blue" to="productions"
          >{{ $tc("productioncompany", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
  
  
      <div class="white-wrapper">
      
        <form>
          <section
            class="mb-3"
          
          >
          <!-- <div class="row col-12">
              <div
                class="section-title mb-2 d-flex justify-content-between section-border section-border col-10"
                style="padding: 6px; align-items: center"
                v-b-toggle.basicInfoCollapse
              >
                <div>
                  <span class="fs"
                    >{{ $tc("basic") }} {{ $tc("information") }}</span
                  ><span class="font-weight-normal fs">{{ basicinfotext }} </span>
  
                
                </div>
                <button type="button" class="btn-transparent chevron">
                  <img
                    src="@/assets/img/icons/primary/chevron-down.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
  
              <div class="col-2 d-flex align-items-center justify-content-center">
                <label class="mb-0">{{ $t("active") }}</label>
                <b-form-checkbox
                  v-model="production_is_active"
                  unchecked-value="N"
                  value="Y"
                  name="check-button"
                  class="j-checkbox ml-2 pb-0"
                />
              </div>
            </div>
            <b-collapse
              id="basicInfoCollapse"
              v-model="sectionCollapse.basicInfo"
            >
            <div style="border-radius: 15px;" class="basicInforWrapper p-2">
              <div class="row px-2">
                <div class="col-md-3 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <label
                          >Name <span class="required_star">*</span></label
                        >
                        <input
                          v-model="productionCompany.production_name"
                          type="text"
                          name="movietitle"
                          id="movietitle"
                          placeholder="Production Company name"
                        />
                      </div>
                    </div>
                    <p class="error_message"></p>
                </div>
                <div class="col-md-3 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <label
                          >Email <span class="required_star">*</span></label
                        >
                        <input
                          v-model="productionCompany.email"
                          type="text"
                          name="movietitle"
                          id="movietitle"
                          placeholder="email"
                        />
                      </div>
                    </div>
                    <p class="error_message"></p>
                </div>
                 
                    <div class="col-md-1 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label>
                          {{ $tc("Code", 1)
                          }}<span class="required_star"></span>
                        </label>
  
                        <multiselect
                          v-model="selected_country_mob_code"
                          placeholder="code"
                          :options="countryList"
                          @select="onSelectCountryMobileCode($event)"
                          @remove="onRemoveCountryMobileCode(index)"
                          label="country_mob_code"
                          track-by="country_mob_code"
                          :multiple="false"
                          name="selectoriginalDistributor"
                          id="selectoriginalDistributor"
                          select-label="Select"
                          deselect-label="Remove"
                        ></multiselect>
                      </div>
                    </div>
                    <p class="error_message"></p>
                  </div>
                     <div class="col-md-2 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <label
                          >Contact No. <span class="required_star">*</span></label
                        >
                        <input
                          v-model="productionCompany.contact_no"
                          type="text"
                          name="movietitle"
                          id="movietitle"
                          placeholder="Contact No"
                        />
                      </div>
                    </div>
                    <p class="error_message"></p>
                </div>
              </div>
              <div class="row px-2">
                   <div class="col-md-3 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <label
                          >Address <span class="required_star">*</span></label
                        >
                        <input
                          v-model="productionCompany.address"
                          type="text"
                          name="movietitle"
                          id="movietitle"
                          placeholder="address"
                        />
                      </div>
                    </div>
                    <p class="error_message"></p>
                </div>
                   <div class="col-md-2 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label>
                          {{ $tc("Country", 1)
                          }}<span class="required_star"></span>
                        </label>
  
                        <multiselect
                          v-model="selected_country"
                          @select="onSelectCountry($event)"
                          @remove="onRemoveCountry(index)"
                          placeholder="Select Country"
                          :options="countryList"
                          label="country_name"
                          track-by="country_name"
                          :multiple="false"
                          name="selectoriginalDistributor"
                          id="selectoriginalDistributor"
                          select-label="Select"
                          deselect-label="Remove"
                        ></multiselect>
                      </div>
                    </div>
                    <p class="error_message"></p>
                  </div>
                  <div class="col-md-2 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label>
                          {{ $tc("state", 1)
                          }}<span class="required_star"></span>
                        </label>
  
                        <multiselect
                          v-model="selected_state"
                          @select="onSelectState($event)"
                          @remove="onRemoveState()"
                          placeholder="Select State"
                          :options="stateList"
                          label="state_name"
                          track-by="state_name"
                          :multiple="false"
                          name="selectoriginalDistributor"
                          id="selectoriginalDistributor"
                          select-label="Select"
                          deselect-label="Remove"
                        ></multiselect>
                      </div>
                    </div>
                    <p class="error_message"></p>
                  </div>
  
                   <div class="col-md-2 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="dropdown-curve-container">
                        <label>
                          {{ $tc("city", 1)
                          }}<span class="required_star"></span>
                        </label>
  
                        <multiselect
                          v-model="selected_city"
                          @select="onSelectCity($event)"
                          @remove="onRemoveCity()"
                          placeholder="Select City"
                          :options="cityList"
                          label="city_name"
                          track-by="city_name"
                          :multiple="false"
                          name="selectoriginalDistributor"
                          id="selectoriginalDistributor"
                          select-label="Select"
                          deselect-label="Remove"
                        ></multiselect>
                      </div>
                    </div>
                    <p class="error_message"></p>
                  </div>
  
                     <div class="col-md-2 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="input-material">
                        <label
                          >Zip Code <span class="required_star"></span></label
                        >
                        <input
                          v-model="productionCompany.zip_code"
                          type="text"
                          name="movietitle"
                          id="movietitle"
                          placeholder="zip Code"
                        />
                      </div>
                    </div>
                    <p class="error_message"></p>
                </div>
              </div>
            </div>
            </b-collapse> -->

            <div class="row  mx-3 back rounded-10 new-border pt-3 mb-2">
            <div  class="row w-100 mx-1">
              <!-------Company Name-------->
              <div class="col-5 ">
                <div class="d-flex align-items-center">
                  <div class="input-material">

                    <input id="cine_address" name="cine_address" v-model="productionCompany.production_name"
                      placeholder="." />
                    <label>{{ $tc("Production", 1) }} {{ $tc("Company", 1) }} {{ $tc("Name", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>

              </div>
              <!--  Country Mobile Code -->
              <div class="col-md-2 ">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                    :class="selected_country_mob_code && selected_country_mob_code.hasOwnProperty('country_mob_code')
                      ? 'shift-up'
                      : 'font-weight-bold'"
                    >
                      {{ $tc("Code", 1)
                      }}
                    </label>

                    <multiselect v-model="selected_country_mob_code" placeholder="code" :options="countryList"
                      @select="onSelectCountryMobileCode($event)" @remove="onRemoveCountryMobileCode(index)"
                      label="country_mob_code" track-by="country_mob_code" :multiple="false"
                      name="selectoriginalDistributor" id="selectoriginalDistributor" select-label="Select"
                      deselect-label="Remove"></multiselect>
                  </div>
                </div>
              </div>
              <!--  Contact No -->

              <div class="col-3 ">
                <div class="d-flex align-items-center">
                  <div class="input-material">

                    <input id="cine_address" name="cine_address" type="number" v-model="productionCompany.contact_no"
                      placeholder="." />
                    <label>{{ $tc("Contact", 1) }} {{ $tc("Number", 1) }} </label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>

              </div>
             
              <div  class="col-2 d-flex align-items-start pt-2 justify-content-start">
                        <label class="mb-0">{{ $t("active") }}</label>
                        <b-form-checkbox

                          v-model="production_is_active"
                          unchecked-value="N"
                          value="Y"
                          name="check-button"
                          class="j-checkbox ml-3 pb-0"
                        />
                      </div>


              </div>
            <div class="row w-100 mx-1 mt-3">

              <!-------------Email ---------->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input id="cine_pincode" name="cine_pincode" v-model="productionCompany.email" placeholder="." />
                    <label>{{ $tc("email", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <!-- <p class="error_message">
                  <span v-if="submitted && errors.has('cine_pincode')">{{
                    errors.first("cine_pincode")
                  }}</span>
                </p> -->
              </div>
              <!-------------Email ---------->

              <!-------------Webiste Url ---------->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input id="cine_pincode" name="cine_pincode" v-model="productionCompany.website_url"
                      placeholder="." />
                    <label>{{ $tc("Website", 1) }} {{ $tc("Url", 1) }}</label>
                  </div>
                </div>

              </div>
              <!-------------Webiste Url ---------->

              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input id="cine_pincode" name="cine_pincode" v-model="productionCompany.remark" placeholder="." />
                    <label>{{ $tc("remark", 1) }} </label>
                  </div>
                </div>

              </div>
            </div>
            <div class="mx-3 back-white w-100 row pt-3  mt-2 mb-3">
              <div class="col-12">
                <h5 class="text-blue">Address</h5>
              </div>
              <div class="col-lg-4 col-xl-4 mb-3">
                <div class="dropdown-curve-container">
                  <label :class="selected_country && selected_country.hasOwnProperty('country_name')
                      ? 'shift-up'
                      : 'font-weight-bold'
                    ">{{ $tc("Country", 1) }}</label>

                  <multiselect :options="countryList" v-model="selected_country" :searchable="true" label="country_name"
                    track-by="country_name" placeholder="" @select="onSelectCountry($event,)"
                    @remove="onRemoveCountry()" select-label="Select" deselect-label="Remove"></multiselect>
                </div>
              </div>

              <!--State-->
              <div class="col-lg-4 col-xl-4 mb-3">
                <div class="dropdown-curve-container">
                  <label :class="selected_state && selected_state.hasOwnProperty('state_name')
                      ? 'shift-up'
                      : 'font-weight-bold'
                    ">{{ $tc("state", 1) }}</label>
                  <multiselect :options="stateList" v-model="selected_state" :searchable="true" label="state_name"
                    track-by="state_name" placeholder="" @select="onSelectState($event)" @remove="onRemoveState()"
                    select-label="Select" deselect-label="Remove"></multiselect>
                </div>
              </div>

              <!--City--->
              <div class="col-lg-4 col-xl-4 mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input id="city_name" name="city_name" v-model="productionCompany.city_name" placeholder="." />
                    <label>{{ $tc("city_name", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
             
              </div>

              <!--Address--->
              <div class="col-lg-4 col-xl-4 mb-3">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input id="cine_address" name="cine_address" v-model="productionCompany.address" placeholder="."
                      />
                    <label>{{ $tc("cine_address", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
                <!-- <p class="error_message">
                  <span v-if="submitted && errors.has('cine_address')">{{
                    errors.first("cine_address")
                  }}</span>
                </p> -->
              </div>

              <!---Country--->

              <!--Zip Code--->
              <div class="col-lg-4 col-xl-4 mb-1">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <!-- @focus="onFocusHandler" -->
                    <!-- :required="item.required" -->
                    <input id="cine_pincode" name="cine_pincode" v-model="productionCompany.zip_code" placeholder="." />
                    <label>{{ $tc("cine_pincode", 1) }}</label>
                  </div>
                  <!--Tooltip :title="$t('cinema_type_name')" /-->
                </div>
              
              </div>
            </div>
          </div>

            <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="handleSubmit(true)"
            >
              {{ $t("save") }}
            </button>
            </div>
          </section>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import MasterService from "@/services/MasterService";
  import Production from "@/helper/formJSONMaster/Production";
  
  export default {
    data() {
      return {
        btenable: false,
        production_id:null,
        Production: Production.ms_production_companies,
        // v-validate="'required|email'"
        submitted: false,
        Methods: Production.Methods,
        production_is_active:"Y",
        sectionCollapse: {
            basicInfo: true,  
          },
          countryList: [],
          stateList:[],
          cityList:[],
          Countries:[],
          selected_country: null,
        selected_state: null,
        selected_city: null,
        selected_contract_id: null,
        selected_country_mob_code:null,
        SelectedCountryCode: "",
        productionCompany:{
          production_name:"",
          country_id:null,
          state_id:null,
          city_id:null,
          address:null,
          zip_code:null,
          email:null,
          website_url:null,
          contact_no:null,
          country_mob_code:null,
          website_url:null,
        city_name:null,
        remark:null
        }
      };
    },
    beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
        this.production_id=id;
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
    mounted() {
      // this.resetHandler();
      this.getCountryList()
    },
    methods: {
      onFocusHandler: function () {
        // this.submitted = false;
      },
      resetHandler: function () {
        this.Production.map((x) => {
          if (x.type === "text" || x.type === "date") {
            x.fieldvalue = "";
          } else if (x.type === "radio") {
            x.fieldvalue = true;
          }
        });
      },
      getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      let loader = this.$loading.show();
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            // this.Production.map((x) => {
            //   if (x.fieldname === "production_is_active") {
            //     x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
            //   } else if (x.type === "date") {
            //     x.fieldvalue = this.formatDate(obj[x.fieldname]);
            //   } else {
            //     x.fieldvalue = obj[x.fieldname];
            //   }
            // });
            this.productionCompany={
            production_name:obj.production_name,
            country_id:obj.country_id,
            state_id:obj.state_id,
            city_id:obj.city_id,
            address:obj.address,
            zip_code:obj.zip_code,
            email:obj.email,
            website_url:obj.website_url ||null,
            contact_no:obj.contact_no,
            country_mob_code:obj.country_mob_code,
            website_url:obj.website_url,
            remark:obj.remark,
            city_name:obj.city_name
            }
          if(obj.country_id){
            this.getCountryList(obj["country_id"],obj["country_mob_code"]);
          }
          if(obj.state_id){
            this.getStateList(obj["state_id"], obj["country_id"]);
          }
          this.production_is_active=obj.production_is_active
        //   if(obj.city_id){
        //     this.getCityList(obj["city_id"], obj["state_id"]);
        //   }

          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
          loader.hide();

        })
        .catch((error) => {
          // Show Catch Error
          loader.hide();
          console.log("show error :", error);
        });
    },
      getCountryList: function(uniqueId,mobCode) {
        this.countryList = [];
        this.stateList = [];
        this.cityList = [];
        this.Countries = [];
        let payload = {
          tableName: "ms_countries",
          country_is_active: "Y"
        };
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.countryList = data.Records;
              this.Countries = data.Records;
  
            //   let globalOptions = this.$store.getters.getGlobalOptions;
            //   if (this.countryList.length > 0 && globalOptions.length > 0) {
            //     let operationCountryId = globalOptions.find(data => {
            //       return data.go_key === "OPERATION_COUNTRY";
            //     });
            //     let countryInfo = this.countryList.find(data => {
            //       return data.country_id == operationCountryId.go_value;
            //     });
            //     this.selected_country = { ...countryInfo };
            //     this.SelectedCountryCode = countryInfo.country_mob_code;
             
            //     // this.getStateList(countryInfo.country_id);
            //   }
              const filteredData = data.Records.filter(record => uniqueId == record.country_id);
                if(uniqueId && filteredData.length){
                    this.selected_country=filteredData[0]
                }
            const filterMobCode=data.Records.filter(record => mobCode == record.country_mob_code);
                if(mobCode && filterMobCode.length){
                    this.selected_country_mob_code=filterMobCode[0]
                }
            } else {
              console.log("show error1 :", data.message);
            }
          })
          .catch(error => {
            console.log("show error2 :", error);
          });
      },
      getStateList: function(uniqueId,countryId) {
        console.log("uniqueId state id=>",)
        this.stateList = [];
        this.cityList = [];
        let payload = {
          tableName: "ms_states",
          state_is_active: "Y",
          country_id: countryId
        };
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            console.log("data :", data);
            if (data.status && data.Records.length > 0) {
              this.stateList = data.Records;  
              const filteredData = data.Records.filter(record => uniqueId == record.state_id);
                if(filteredData.length){
                    this.selected_state=filteredData[0]
                } 
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch(error => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      getCityList: function(uniqueId,stateId) {
        this.cityList = [];
        let payload = {
          tableName: "ms_cities",
          city_is_active: "Y",
          state_id: stateId
        };
        MasterService.GetActiveList(payload)
          .then(response => {
            const { data } = response;
            console.log("data :", data);
            if (data.status && data.Records.length > 0) {
              this.cityList = data.Records;
              const filteredData = data.Records.filter(record => uniqueId == record.city_id);
                if(filteredData.length){
                    this.selected_city=filteredData[0]
                }
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch(error => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      onSelectCountry(Country) {
        this.productionCompany.country_id=Country.country_id
        this.productionCompany.state=null
        this.productionCompany.city=null
        this.selected_state = null;
        this.selected_city = null;
        this.getStateList(null,Country.country_id);
      },
      onRemoveCountry(mainIndex) {
        this.stateList = [];
        this.selected_state = null;
        this.cityList = [];
        this.selected_city = null;
        this.productionCompany.country_id=null;
        this.productionCompany.state_id=null
        this.productionCompany.city_id=null
      },
      onSelectState(State) {
        this.productionCompany.state_id=State.state_id
       this.productionCompany.city_id=null
        this.selected_city = null;
    
        this.getCityList(null,State.state_id);
     
      },
      onRemoveState(mainIndex) {
        this.cityList = [];
        this.selected_city = null;
        this.productionCompany.state_id=null
        this.productionCompany.city_id=null
      },
      onSelectCity(cityData){
      this.productionCompany.city_id=cityData.city_id
      },
      onSelectCountryMobileCode(countryData){
        this.productionCompany.country_mob_code=countryData.country_mob_code
      },
      onRemoveCountryMobileCode(){
        this.productionCompany.country_mob_code=null;
        this.selected_country_mob_code=null
      },
      isValidEmail(email) {
    const regex = /^(?!@)(?!.*@.*@)(?!.*\.\.)(?!.*\.$)(?!.*-)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return regex.test(email);
    },
     isValidURL(url) {
    const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9\-._~:\/?#[\]@!$&'()*+,;=%]*)?$/;
    return regex.test(url);
    },
      dataValidation() {
      if (!this.productionCompany.production_name) {
        return {
          status: false,
          message: "Production company name is required"
        };
      }

      if (!this.productionCompany.email) {
        return {
          status: false,
          message: "Email is required"
        };
      }



      // Validate contact number
      if (!this.productionCompany.contact_no) {
        return {
          status: false,
          message: "Contact number is required"
        };
      }


      if (!this.productionCompany.address) {
        return {
          status: false,
          message: "Address is required"
        };
      }

      // Validate country mobile code
      if (!this.productionCompany.country_mob_code) {
        return {
          status: false,
          message: "Country mobile code is required"
        };
      }

      if (!this.productionCompany.zip_code) {
        return {
          status: false,
          message: "zip code is required"
        };
      }
      if (!this.selected_country) {
        return {
          status: false,
          message: "Country is required"
        };
      }
      if (!this.selected_state) {
        return {
          status: false,
          message: "State is required"
        };
      }

      if(!this.productionCompany.city_name){
        return {
          status: false,
          message: "City is required"
        };
      }

      if(this.productionCompany.email){
        let result=this.isValidEmail(this.productionCompany.email)
        console.log("check for valid email=>",result)
        if(!result){
          return {
          status: false,
          message: "Enter valid email"
        };
        }
      }
      
      if(this.productionCompany.website_url){
        let result=this.isValidURL(this.productionCompany.website_url)
        console.log("check for valid url=>",result)
        if(!result){
          return {
          status: false,
          message: "Enter valid webiste url"
        };
        }
      }

      return { status: true };
    },
  
      // handleSubmit(flag) {
      //   console.log("call submit :");
      //   this.submitted = true;
      //   this.$validator.validate().then((valid) => {
      //     console.log("valid :", valid);
      //     if (valid) {
      //       this.btenable = true;
      //       console.log("valid :", valid);
      //       let body = this.getRequestBody("POST", this.Production, this.Methods);
      //       console.log("body :", body);
  
      //       MasterService.GlobalRequest(body)
      //         .then((response) => {
      //           this.btenable = false;
      //           const { data } = response;
      //           if (data.status) {
      //             console.log("here :", data);
      //             if (flag) {
      //               this.resetHandler();
      //               this.$router.push({
      //                 path: "/master/productions",
      //               });
      //             } else {
      //               this.resetHandler();
      //             }
      //           } else {
      //             this.$toasted.show(data.message);
      //             console.log("show error1 :", data.message);
      //           }
      //         })
      //         .catch((error) => {
      //           console.log("show error2 :", error);
      //         });
      //     } else {
      //       console.log("else :");
      //     }
      //   });
      // },
  
      handleSubmit(){
        
        let result= this.dataValidation();
        if(!result.status){
          return this.$toasted.show(result.message);
        }
        let payload={
          ...this.productionCompany,
          production_is_active:this.production_is_active
        }
        if(this.production_id){
            payload.production_id=this.production_id
        }
        let loader = this.$loading.show();
  
        MasterService.addEditProductionCompany(payload).then((response)=>{
          const { data } = response;
          loader.hide();
          if (data.status) {
            return this.$router.push({ path: "/distributor/productions", });
          }
          else{
           return  this.$toasted.show(data.message);
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          loader.hide();
           console.log("show error2 :", error);
        });
      },
    },
  };
  </script>
  <style>
  .distributor-section-new .input-material input {
    background-color: white !important;
  }
  
  .new-border {
    border: 2px solid #b1b4b8;
  }
  
  label {
    color: black !important;
  }
  
  .internal-border-new {
    border: 1px solid #3876d2;
    /*background-color: #e6e6f8;*/
  }
  
  .internal-border {
    border: 1px solid #3876d2;
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }
  
  .fs {
    font-size: 17px;
  }
  
  .back {
    background-color: #f5f5f5;
  }
  
  .mar {
    margin-left: 30px;
  }
  
  .back-white {
    background-color: white;
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }
  .text-blue{
  color:#3876d2;
  padding: 0 10px;
   font-weight: 700;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ProductionCompany/editProductionV2.vue